export enum optionsSymbol {
  'A',
  'B',
  'C',
  'D'
}

export default { optionsSymbol };
